import React from 'react';
import { StyleSheet, Text, TouchableOpacity } from 'react-native';
import { agenda, agendaFonts } from '../domain/agendaTheme';

type Props = {
  onCreate: () => void;
  canManage: boolean;
};

export function AgendaListActions({ onCreate, canManage }: Props) {
  return (
    <TouchableOpacity
      style={[styles.primary, !canManage && styles.disabled]}
      onPress={onCreate}
      disabled={!canManage}
      accessibilityRole="button"
      accessibilityLabel="Nueva agenda"
      testID="appointments.resources.new"
    >
      <Text style={styles.primaryText}>+ Nueva agenda</Text>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  primary: {
    height: 36,
    borderRadius: agenda.radius,
    backgroundColor: agenda.brand,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 14,
    flexShrink: 0,
  },
  primaryText: {
    fontSize: 13,
    fontWeight: '700',
    color: agenda.brandInk,
    fontFamily: agendaFonts.sans,
  },
  disabled: { opacity: 0.55 },
});
